import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Button } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import Axios from 'axios'
import Swal from 'sweetalert2'

export default function Activation() {
    const { t } = useTranslation()
    const {idUser} = useParams()
    const [isActivated, setIsActivated] = useState('loading')

    useEffect(() => {
        Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/activate/' + idUser)
            .then(() => setIsActivated('success'))
            .catch(() => setIsActivated('error'))
    }, [idUser])

    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <Link to='/'><img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} /></Link>
            </header>
            <Container fluid className='p-0 m-0'>
                <Row className='p-0 m-0 centro-auth'>
                    <Col md={7} className='d-none d-md-flex align-items-center justify-content-center aside-auth' style={{
                        background: 'linear-gradient(135deg, #0B0C0E 0%, #1A1B1E 100%)',
                    }}>
                        <div style={{maxWidth: 420, color: 'white', padding: 40}}>
                            <h1 style={{color: 'white', fontSize: 40, marginBottom: 16}}>SDPlay</h1>
                            <p style={{fontSize: 16, opacity: 0.7, lineHeight: 1.6}}>Activaci&oacute;n de cuenta</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} className='d-flex align-items-center justify-content-center p-5'>
                        <div className='login-form-container text-center'>
                            {isActivated === 'loading' &&
                                <>
                                    <div className="spinner-border mb-4" role="status" style={{width: 40, height: 40, color: '#D1D5DB'}} />
                                    <p>{t('global.loading')}...</p>
                                </>
                            }
                            {isActivated === 'success' &&
                                <>
                                    <div className='login-brand text-center'>
                                        <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                                    </div>
                                    <h1 className='login-title'>{t('activation.success')}</h1>
                                    <p className='login-subtitle'>{t('activation.successmessage')}</p>
                                    <Link to={`/${t("url.auth.login")}`} className='btn btn-primary w-100 mt-4'>
                                        {t('signin.login')}
                                    </Link>
                                </>
                            }
                            {isActivated === 'error' &&
                                <>
                                    <div className='login-brand text-center'>
                                        <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                                    </div>
                                    <h1 className='login-title'>{t('activation.error')}</h1>
                                    <p className='login-subtitle'>{t('activation.errormessage')}</p>
                                    <Link to='/' className='btn btn-default w-100 mt-4'>
                                        {t('global.goback')}
                                    </Link>
                                </>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}